import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Car, FileText, Calendar } from "lucide-react";

export default function AdministrationPage() {
  const [vehicles, setVehicles] = useState([]);
  const [files, setFiles] = useState([]);
  const [meetings, setMeetings] = useState([]);
  useEffect(() => {
    api.get("/erp/admin/vehicles").then((r) => setVehicles(r.data.items));
    api.get("/erp/admin/files").then((r) => setFiles(r.data.items));
    api.get("/erp/admin/meetings").then((r) => setMeetings(r.data.items));
  }, []);
  return (
    <div className="space-y-6">
      <div>
        <div className="label-tiny text-[hsl(var(--primary))]">Administration</div>
        <h1 className="mt-1 text-3xl font-heading font-bold">Vehicles · Files · Meetings</h1>
      </div>

      <div className="grid lg:grid-cols-2 gap-4">
        <div className="rounded-2xl border border-border bg-card p-5">
          <div className="font-heading font-semibold flex items-center gap-2"><Car className="h-4 w-4"/>Vehicle Pool</div>
          <div className="mt-3 overflow-x-auto">
            <table className="w-full">
              <thead><tr>
                <th className="table-th">Reg No</th><th className="table-th">Model</th><th className="table-th">Type</th><th className="table-th">Status</th>
              </tr></thead>
              <tbody>
                {vehicles.map(v => (
                  <tr key={v.id} className="border-t border-border">
                    <td className="table-cell font-mono">{v.reg_no}</td>
                    <td className="table-cell">{v.model}</td>
                    <td className="table-cell">{v.type}</td>
                    <td className="table-cell"><span className={`stat-pill capitalize ${v.status === "available" ? "bg-emerald-500/10 text-emerald-500" : v.status === "on_trip" ? "bg-sky-500/10 text-sky-500" : "bg-amber-500/10 text-amber-500"}`}>{v.status.replace("_"," ")}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="rounded-2xl border border-border bg-card p-5">
          <div className="font-heading font-semibold flex items-center gap-2"><FileText className="h-4 w-4"/>File Tracker</div>
          <div className="mt-3 overflow-x-auto">
            <table className="w-full">
              <thead><tr>
                <th className="table-th">File</th><th className="table-th">Subject</th><th className="table-th">Desk</th><th className="table-th">Days</th>
              </tr></thead>
              <tbody>
                {files.map(f => (
                  <tr key={f.id} className="border-t border-border">
                    <td className="table-cell font-mono text-xs">{f.file_no}</td>
                    <td className="table-cell">{f.subject}</td>
                    <td className="table-cell text-muted-foreground">{f.current_desk}</td>
                    <td className="table-cell"><span className={`font-semibold ${f.days_pending > 10 ? "text-red-500" : f.days_pending > 5 ? "text-amber-500" : ""}`}>{f.days_pending}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="rounded-2xl border border-border bg-card p-5">
        <div className="font-heading font-semibold flex items-center gap-2"><Calendar className="h-4 w-4"/>Upcoming Meetings</div>
        <div className="mt-3 grid md:grid-cols-2 lg:grid-cols-4 gap-3">
          {meetings.map(m => (
            <div key={m.id} className="rounded-lg border border-border p-3">
              <div className="text-xs text-muted-foreground">{m.date} · {m.time}</div>
              <div className="mt-1 font-medium">{m.title}</div>
              <div className="text-xs text-muted-foreground mt-1">{m.location}</div>
              <div className="mt-2"><span className={`stat-pill capitalize ${m.status === "scheduled" ? "bg-sky-500/10 text-sky-500" : m.status === "completed" ? "bg-emerald-500/10 text-emerald-500" : "bg-slate-500/10 text-slate-500"}`}>{m.status}</span></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
